import api from './api';

const UserService = {
  async getProfile() {
    const { data } = await api.get('/users/profile');
    return data.data;
  },

  async updateProfile(updates) {
    const { data } = await api.put('/users/profile', updates);
    return data.data;
  },

  async getReferralCode() {
    const { data } = await api.get('/users/referral-code');
    return data.data;
  },

  async lookupReferral(code) {
    const { data } = await api.get(`/users/referral/${code}`);
    return data.data;
  },

  async uploadDocument(docKey, file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post(`/users/documents/${docKey}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data;
  },

  async listDocuments() {
    const { data } = await api.get('/users/documents');
    return data.data;
  },

  async changePassword(oldPassword, newPassword) {
    const { data } = await api.patch('/users/change-password', { oldPassword, newPassword });
    return data;
  },

  async verifyPassword(password) {
    const { data } = await api.post('/users/verify-password', { password });
    return data.data;
  },

  async fixAuthProvider() {
    const { data } = await api.post('/users/fix-auth');
    return data;
  },
};

export default UserService;
